import { render, staticRenderFns } from "./supervisionManagmentLists.vue?vue&type=template&id=0f5a53cb&scoped=true"
import script from "./supervisionManagmentLists.vue?vue&type=script&lang=js"
export * from "./supervisionManagmentLists.vue?vue&type=script&lang=js"
import style0 from "./supervisionManagmentLists.vue?vue&type=style&index=0&id=0f5a53cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a53cb",
  null
  
)

export default component.exports